import React from "react";
import { ListingBadges } from "@domain-group/fe-allhomes-library";
import * as styles from "./allhomes-listing-badges.style";
import { ListingBadge } from "./listing-badge";
import { jsx as ___EmotionJSX } from "@emotion/core";
var reduceBadges = (list, annotation) => {
  var badge = ListingBadges[annotation.badge];
  if (!badge) {
    return list;
  }
  var existingBadge = list[badge.priority];
  if ((existingBadge === null || existingBadge === void 0 ? void 0 : existingBadge.groupedPriority) !== undefined && (badge === null || badge === void 0 ? void 0 : badge.groupedPriority) !== undefined && existingBadge.groupedPriority < badge.groupedPriority) {
    return list;
  }
  list[badge.priority] = {
    groupedPriority: badge.groupedPriority,
    badge,
    annotation
  };
  return list;
};
var getLabel = (annotation, labelType) => {
  switch (labelType) {
    case "full":
      return annotation.label;
    case "short":
      return annotation.shortLabel;
    default:
      return annotation.tinyLabel;
  }
};
export var AllhomesListingBadges = _ref => {
  var _ref$annotations = _ref.annotations,
    annotations = _ref$annotations === void 0 ? [] : _ref$annotations,
    _ref$labelType = _ref.labelType,
    labelType = _ref$labelType === void 0 ? "tiny" : _ref$labelType,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "medium" : _ref$size;
  return ___EmotionJSX("div", {
    css: styles.wrapper(size),
    "data-testid": "badges"
  }, annotations.reduce(reduceBadges, []).map(_ref2 => {
    var annotation = _ref2.annotation,
      badge = _ref2.badge;
    return ___EmotionJSX(ListingBadge, {
      badge: badge,
      label: getLabel(annotation, labelType),
      size: size,
      key: badge.name
    });
  }));
};